import React from "react";

// Wrapper Component
const Wrapper = ({ condition, wrapper, children }) => {
  return condition ? wrapper(children) : children;
};

const EmailField = ({
  label,
  name,
  placeholder,
  required,
  readonly,
  value,
  idField,
  onChangeHandler,
  labelWrapperClassName,
  isValid = true,
  errorMessage = "",
  customErrorInputStyle = null,
  customErrorLabelStyle = null,
  customErrorMessageStyle = null,
  description,
  explanation,
  ...props
}) => {
  const getInputStyles = (isValid, customErrorInputStyle) => {
    if (!isValid && customErrorInputStyle) {
      return customErrorInputStyle;
    }
    return {
      border: isValid ? "1px solid #ccc" : "1px solid #960000",
      background: isValid ? "" : "#f9f0f0",
      width: "100%",
    };
  };

  const getLabelStyles = (isValid, customErrorLabelStyle) => {
    if (!isValid && customErrorLabelStyle) {
      return customErrorLabelStyle;
    }
    return {
      color: isValid ? "" : "#960000",
    };
  };

  return (
    <div className="tps-form-question">
      <Wrapper
        condition={!labelWrapperClassName}
        wrapper={(children) => <div className="tps-form-label">{children}</div>}
      >
        <label
          style={getLabelStyles(isValid, customErrorLabelStyle)}
          className={`${
            required ? "tps-field-required tps-to-validate" : "tps-not-required"
          }`}
          htmlFor={idField}
        >
          {label}
        </label>
        {!!explanation && explanation !== "" && (
          <div className="fas fa-info-circle tps-form-tip has-tip">
            <div
              className="tooltiptext"
              dangerouslySetInnerHTML={{ __html: explanation }}
            ></div>
          </div>
        )}
      </Wrapper>

      <Wrapper
        wrapper={(children) => <div className="tps-form-input">{children}</div>}
      >
        <input
          style={getInputStyles(isValid, customErrorInputStyle)}
          id={idField || name}
          name={name}
          type="email"
          placeholder={placeholder}
          required={required}
          readOnly={readonly}
          value={value}
          onChange={(event) => onChangeHandler(event)}
          suppressHydrationWarning={true}
          {...props}
        />
        {!isValid && (
          <span
            className="EditingFormErrorLabel"
            style={customErrorMessageStyle}
          >
            {errorMessage}
          </span>
        )}
        {!!description && description !== "" && (
          <p
            className="tps-form-input-explaination"
            dangerouslySetInnerHTML={{ __html: description }}
          ></p>
        )}
      </Wrapper>
    </div>
  );
};

export default EmailField;
